

<template>

  <div class="question">
  <div v-if="showQ">
  <Pair />  
  </div>
  <div v-if="showTerms">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <h3>Instructions:</h3>
        <br>
        <ol class="text-left">
          <li>First choose the item in the column that is more like you.</li>
          <li>Then rate how much it is like you from 1 - 7 with 7 the highest rating you can give.</li>
          <li>Both choices may feel like you; choose and rate the strongest choice. You will choose the column and rate your choice on every page of the survey to follow.</li>
        </ol>
        <img class="img-fluid" src="/static/pair.png" >
        <br>
        <br>
        <button class="btn btn-success" v-on:click="acceptTerms">Agree & Start Survey</button>
      </div>
    </div>
  </div>
  <div v-show="!showQ && !showTerms">
    <form v-on:submit="acceptUser">
      <div class="row justify-content-center">
        <div class="col-md-6  text-left" id="infoBox">
          <h4 class="text-primary">Your Information:</h4>
          <br>

          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Email Address:<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-8">
              <input type="email" readonly class="form-control" placeholder="Email" v-model="info.email" required>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Age:<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-3">
              <input type="number" class="form-control" placeholder="Age" v-model="info.age" max="120" required>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Gender:<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-3">
              <select name="" id="" class="form-control" v-model="info.gender" required>
                        <option value="" disabled>Select</option>
              
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        
                    </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Industry of occupation:<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-5">
              <select name="" id="" class="form-control" v-model="info.occupation" required>
                    <option value="" disabled>Select</option>
                        <option v-for="industry in industries" v-bind:value="industry.value">{{industry.value}}</option>    
              </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Role in organization:</label>
            </div>
            <div class="col-sm-5">
              <select name="" id="" class="form-control" v-model="info.role">
                        <option value="" disabled>Select</option>
              
                        <option v-for="role in roles" v-bind:value="role.value">{{role.value}}</option>
                        
                        
                    </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Level of education:<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-5">
              <select name="" id="" class="form-control" required v-model="info.education">
                        <option value="" disabled>Choose Highest Education Level Attained</option>              
                        <option v-for="edu in educations" v-bind:value="edu.value">{{edu.value}}</option>
                        
                        
                    </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              <label for="">Preferred Nationality:</label>
            </div>
            <div class="col-sm-5">
              <select name="" id="" class="form-control" v-model="info.nationality">
                        <option value="" disabled>Select</option>
                        <option v-for="nation in nationalities" v-bind:value="nation.value">{{nation.value}}</option>
                        
                        
                    </select>
            </div>
          </div>



        </div>

        <div class="col-md-4 text-left">
          <h4 class="text-danger">Instructions:</h4>
          <br>  
          <ul>
            <li><span class="text-danger">*</span> Required fields.</li>
            <li>We will never share your information.</li>
          </ul>
        </div>
      </div>
      <br>
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-sm-3">

            </div>
            <div class="col-sm-8">
              <button type="submit" class="btn btn-success btn-block">Next</button>
            </div>
          </div>
        </div>

      </div>
    </form>
    </div>
   
  </div>
</template>

<script>
import Pair from './Pair';
import Terms from './Instruction';


const apiUrl = 'https://t3.talkingtowardtruth.org/api/';
var user= true;
  export default {
    name: 'Question',
    components: {
      Pair,Terms
    },
    data() {
      return {
        showQ : false,
        showTerms : false,
        educations : [],
        industries : [],
        roles : [],
        nationalities : [],
        info : {
            email : this.$cookie.get('email'),
            age : null,
            gender : '',
            occupation : '',
            role : '',
            education : '',
            nationality : ''
        }
      }
    },
    methods: {
        acceptUser : function(e){
            e.preventDefault();
            var token = this.$cookie.get('token');
            console.log(this.info);
            this.$http.post(apiUrl+'user_info/'+token,this.info).then(response=>{
                console.log(response.body);
                if(response.body.userid){
                  this.$cookie.set('user_id',response.body.userid);
                  this.showTerms = true;
                }else{
                  console.log(response.body);
                }
            },error=>{
                console.log(error);
            })
        },
        acceptTerms : function(){
          this.showTerms= false;
          this.showQ = true;
        },
        loadDropdowns : function(){
          this.loadEducations();
          this.loadIndustries();
          this.loadNationalities();
          this.loadRoles();
        }
        ,
        loadEducations : function(){
            this.$http.get(apiUrl+'educations').then(response => {
              this.educations = response.body;
            },error => {
              console.log(error);
            })
        },
        loadIndustries : function(){
            this.$http.get(apiUrl+'industries').then(response => {
              this.industries = response.body;
            },error => {
              console.log(error);
            })
        },
        loadNationalities : function(){
            this.$http.get(apiUrl+'nationalities').then(response => {
              this.nationalities = response.body;
            },error => {
              console.log(error);
            })
        },
        loadRoles : function(){
            this.$http.get(apiUrl+'roles').then(response => {
              this.roles = response.body;
            },error => {
              console.log(error);
            })
        }
    },
    created : function() {
      this.loadDropdowns();
      var token = this.$cookie.get('token');
      console.log(token);
      if(token){
        if(this.$cookie.get('user_id')){
                  this.showQ = true;          
        }else{
          this.showQ= false;
        }
      }else{
        console.log('no token found')
        this.$router.push('');
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #infoBox {
    border-right: 1px solid rgba(204, 204, 204, 0.33);
  }

</style>



// WEBPACK FOOTER //
// src/components/Question.vue